import React, { useState } from "react";
import "./Newsletter.css";
import { Link } from "react-router-dom";
import { FORMSPREE_ENDPOINT } from "../../config/formspree";

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ email, _subject: 'Newsletter Subscription — Sendcheap' }),
      });
      const data = await res.json();
      if (data.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="newsletter">
      <div className="nl-inner">
        <span className="nl-label">Newsletter</span>
        <h2 className="nl-title">Stay in the loop.</h2>
        <p className="nl-desc">
          Get product updates, fintech news, and exclusive offers delivered
          straight to your inbox. No spam, ever.
        </p>

        {status === 'success' ? (
          <div className="nl-success">
            <span className="nl-success-icon">✓</span>
            <p>You're subscribed! We'll be in touch soon.</p>
          </div>
        ) : (
          <form className="nl-form" onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Enter your email address"
              className="nl-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button
              className="nl-btn"
              type="submit"
              disabled={status === 'submitting'}
            >
              {status === 'submitting' ? 'Subscribing…' : 'Subscribe'}
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="nl-error">Something went wrong. Please try again.</p>
        )}

        <p className="nl-privacy">
          We respect your privacy. Read our{" "}
          <Link to="/privacy-policy">privacy policy</Link>.
        </p>
      </div>
    </section>
  );
};

export default Newsletter;
